module.exports = __webpack_public_path__ + "img/bookdl.99f7c874.gif";